import { render, staticRenderFns } from "./NewsSetup.vue?vue&type=template&id=4dd243c8"
import script from "./NewsSetup.vue?vue&type=script&lang=js"
export * from "./NewsSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports